import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { explain } from "@/lib/insights";
import { money } from "@/lib/format";

export const Tip = ({ text, testId }) => (text ? (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" className="tip-btn" aria-label="What is this?" data-testid={testId}><Info className="h-3 w-3" /></button>
    </PopoverTrigger>
    <PopoverContent side="top" className="w-64 p-2.5 text-xs leading-snug text-slate-700">{text}</PopoverContent>
  </Popover>
) : null);

const val = (v, m) => (typeof v === "number" ? m(v) : v);

export const Explain = ({ s, k, cur, children, testId, className = "" }) => {
  const m = (v) => money(v, cur);
  const e = explain(s, k, m);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className={`explain-trigger ${className}`} data-testid={testId} title="How is this calculated?">{children}</button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-3" align="start" data-testid={`${testId}-popover`}>
        <p className="font-heading text-sm font-bold text-slate-900">{e.title}</p>
        <p className="mb-2 text-[11px] text-slate-500">Where this number comes from</p>
        <div className="space-y-1 text-xs">
          {e.lines.map(([l, v, kind]) => (
            <div key={l} className={`flex justify-between gap-3 ${kind === "sub" ? "border-t border-slate-200 pt-1 font-semibold text-slate-900" : ""}`}>
              <span className="text-slate-600">{l}</span><span className="font-mono">{val(v, m)}</span>
            </div>
          ))}
        </div>
        <div className="mt-2 flex justify-between border-t-2 border-slate-300 pt-2 text-sm font-bold">
          <span>{e.total[0]}</span><span className="font-mono" data-testid={`${testId}-total`}>{e.total[1] === null ? "-" : m(e.total[1])}</span>
        </div>
        {e.note && <p className="mt-2 text-[11px] text-slate-500">{e.note}</p>}
      </PopoverContent>
    </Popover>
  );
};
